import React from 'react';
import { Routes, Route } from "react-router-dom";
import '../tailwind.css';

import Home from './pages/Home';
import Course from './pages/Course';
import Module from './pages/Module';
import CourseApplication from './pages/CourseApplication';

const FrontendApp = () => (
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="course" element={<Course />} />
        <Route path="course/:courseId" element={<Course />} />
        <Route path="course/:courseId/module/:moduleId" element={<Module />} />
        <Route path="course/application" element={<CourseApplication />} />
        <Route path="course/:courseId/application" element={<CourseApplication />} />
    </Routes>
);

export default FrontendApp;